import Button from '@/shared/Button/Button';
import useHelpButton from './useHelpButton.hook';
import { Modal } from 'antd';

export default function HelpButton({ icon }) {
  const { state, actions } = useHelpButton();
  return (
    <>
      <Button
        size="small"
        type="link"
        icon={icon}
        onClick={actions.toggleModalOpened}
      ></Button>
      <Modal
        title="Help"
        visible={state.modalOpened}
        footer={null}
        onCancel={actions.toggleModalOpened}
        zIndex={9999999}
      >
        <ul>
          <li>
            You can read the comic on your own, or click on the play icon to
            listen to it (recommended).
          </li>
          <li>
            If you don't understand some words or need help with how they are
            pronounced, click on the bubble to see the translation and to listen
            to the sentence.
          </li>
          <li>Use the arrows to navigate between pages.</li>
        </ul>
      </Modal>
    </>
  );
}
